var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as Sentry from '@sentry/react';
import ErrorHandled from './ErrorHandled.js';
import { ReportError } from './errors.js';
const serializeResponse = (response) => __awaiter(void 0, void 0, void 0, function* () {
    let body;
    try {
        if (response.bodyUsed) {
            body = '<already processed>';
        }
        else {
            body = yield response.text();
        }
    }
    catch (e) {
        body = `[${e instanceof Error ? e.message : 'unknown'}]`;
    }
    return {
        rawStatusCode: `${response.status} (${response.statusText})`,
        headers: Object.fromEntries(response.headers.entries()),
        body,
    };
});
const reportError = ({ error, apiError, extraScope, }) => {
    Sentry.captureException(error, (scope) => {
        scope = scope.clone();
        if (extraScope) {
            scope = extraScope(scope);
        }
        if (apiError != null) {
            scope.setContext('apiError', apiError);
        }
        return scope;
    });
};
/**
 * Generate a onError function that handles reporting errors to Sentry
 *
 * @param errorHandler see type documentation
 */
const onErrorHandler = (errorHandler) => (error) => {
    var _a;
    const result = (_a = errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error)) !== null && _a !== void 0 ? _a : ErrorHandled.NotHandled;
    // "not an error"
    if (result === ErrorHandled.Handled) {
        return;
    }
    const extraScope = result === ErrorHandled.NotHandled ? null : result;
    if (error instanceof ReportError) {
        serializeResponse(error.response.response).then((serializedResponse) => {
            var _a;
            const { url, method, parameters, operationId } = (_a = error.response.request) !== null && _a !== void 0 ? _a : {};
            reportError({
                error,
                extraScope,
                apiError: Object.assign({ operationId,
                    method,
                    url, parameters: JSON.stringify(parameters), clientStatusCode: error.response.status, data: JSON.stringify(error.response.data, null, ' ') }, serializedResponse),
            });
        });
    }
    else {
        reportError({
            error,
            extraScope,
        });
    }
};
export default onErrorHandler;
//# sourceMappingURL=onErrorHandler.js.map